import { Avatar, Box, Drawer, Tooltip } from '@mui/material'
import { GetActivityColor, GetActivityText, getStatusAvatar } from 'components/common/activitySelector'
import useInnovaTheme from 'components/common/hooks/useInnovaTheme'
import React, { useState } from 'react'

import StyledBadge from '../StyledBadge'
import WellSelectorList from './WellSelectorList'
import { currentWellDetailsSelector } from 'atoms'
import { styled, alpha } from '@mui/material/styles'
import { useRecoilValue } from 'recoil'

const StyledAvatarContainer = styled(Box)({
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '8px',
  padding: '5px',
  zIndex: 10,
  cursor: 'pointer',
})

const WellDrawer = ({ selectorToggle, setSelectorToggle }) => {
  const onCloseDrawer = (event) => {
    setSelectorToggle(false)
  }

  return (
    <React.Fragment>
      <Drawer
        anchor='right'
        disableEnforceFocus
        open={selectorToggle}
        onClose={onCloseDrawer}
        PaperProps={{ sx: { backgroundColor: 'itemBackground' } }}>
        <WellSelectorList />
      </Drawer>
    </React.Fragment>
  )
}

const WellSelector = () => {
  const { getLogoColor } = useInnovaTheme()
  const currentWellDetails = useRecoilValue(currentWellDetailsSelector)
  const [selectorToggle, setSelectorToggle] = useState(false)

  const onSelectWell = () => {
    setSelectorToggle(!selectorToggle)
  }

  return (
    <React.Fragment>
      <Tooltip
        title={'Select Well'}
        placement='bottom'
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: 'rgb(19,62,96)',
              fontSize: '12px',
              fontFamily: 'Roboto',
            },
          },
        }}>
        <StyledAvatarContainer
          onClick={() => onSelectWell()}
          sx={{
            border: `1px solid ${alpha(getLogoColor(), 0.8)}`,
            backgroundColor: alpha(getLogoColor(), 0.7),
            '&:hover': {
              backgroundColor: alpha(getLogoColor(), 0.9),
            },
          }}>
          <StyledBadge
            badgecolor={GetActivityColor(currentWellDetails.wellStatus)}
            badgeContent={GetActivityText(currentWellDetails.wellStatus)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}>
            <Avatar
              alt='Well Icon'
              src={getStatusAvatar(currentWellDetails.wellStatus)}
              style={{ height: '28px', width: '28px', boxSizing: 'border-box' }}></Avatar>
          </StyledBadge>
        </StyledAvatarContainer>
      </Tooltip>
      <WellDrawer selectorToggle={selectorToggle} setSelectorToggle={setSelectorToggle} />
    </React.Fragment>
  )
}

export default WellSelector
